import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import textContentSmarthomeContactUsSection from "../../smarthome/ui/textContent-smarthome-contactUsSection";
import CONTROLLERDIN_1 from "../../../assets/products/CONTROLLERDIN_1.png";
import noInternetIcon from "../../../assets/smarthome/noInternetIcon.png";
import iotIcon from "../../../assets/smartbuilding/edgeComputing/iot.png";
import dataLocalIcon from "../../../assets/smarthome/dataLocalIcon.png";
import localIntelligenceIcon from "../../../assets/smarthome/localIntelligenceIcon.png";
import updateIcon from "../../../assets/smarthome/updateIcon.png";
import neverStopIcon from "../../../assets/smarthome/neverStopIcon.png";
import interoperableIcon from "../../../assets/smarthome/interopableIcon.png";

export default function EdgeComputingSection(props) {
  const { textContent, language } = { ...props };
  const screenWidth = useSelector((state) => state.screen.screenWidth);
  const isMobile = useSelector((state) => state.screen.isMobile);

  return (
    <section className="container edgeComputing">
      <div className="container-small edgeComputing">
        <h1 className="h1-edgeComputing">
          <span className="glow">
            {textContent.edgeComputingSection.intro[language]}
          </span>
          {textContent.edgeComputingSection.title[language]}
        </h1>
        <h3 className={`h3-edgeComputing ${isMobile ? "mobile" : ""}`}>
          {textContent.edgeComputingSection.description[language]}
        </h3>
      </div>
      <div className={`edge-description ${isMobile ? "mobile" : ""}`}>
        <div className={`descriptionColumn ${isMobile ? "mobile" : ""}`}>
          <div className="descriptionItem">
            <img
              src={iotIcon}
              aria-hidden="true"
              className={`descriptionIcon ${isMobile ? "mobile" : ""}`}
            />
            <h2 className={`h2-edgeComputing ${isMobile ? "mobile" : ""}`}>
              {
                textContent.edgeComputingSection.features.feature3.title[
                  language
                ]
              }
            </h2>
            <p className="p-edgeComputing">
              {
                textContent.edgeComputingSection.features.feature3.description[
                  language
                ]
              }
            </p>
          </div>
          <div className="descriptionItem">
            <img
              src={noInternetIcon}
              aria-hidden="true"
              className={`descriptionIcon ${isMobile ? "mobile" : ""}`}
            />
            <h2 className={`h2-edgeComputing ${isMobile ? "mobile" : ""}`}>
              {
                textContent.edgeComputingSection.features.feature1.title[
                  language
                ]
              }
            </h2>
            <p className="p-edgeComputing">
              {
                textContent.edgeComputingSection.features.feature1.description[
                  language
                ]
              }
            </p>
          </div>
          <div className="descriptionItem">
            <img
              src={localIntelligenceIcon}
              aria-hidden="true"
              className={`descriptionIcon ${isMobile ? "mobile" : ""}`}
            />
            <h2 className={`h2-edgeComputing ${isMobile ? "mobile" : ""}`}>
              {
                textContent.edgeComputingSection.features.feature2.title[
                  language
                ]
              }
            </h2>
            <p className="p-edgeComputing">
              {
                textContent.edgeComputingSection.features.feature2.description[
                  language
                ]
              }
            </p>
          </div>
        </div>

        <div className={`edge-image ${isMobile ? "mobile" : ""}`}>
          <img src={CONTROLLERDIN_1} aria-hidden="true" />
        </div>
      </div>

      <div className={`edgeSubtitle ${isMobile ? "mobile" : ""}`}>
        <h2 className={`h2-edgeSubtitle ${isMobile ? "mobile" : ""}`}>
          {textContent.edgeComputingSection.subtitle[language]}
        </h2>
        {isMobile ? <div className="container-empty-extra-small" /> : null}
        {isMobile ? (
          <div className="edgeFeature mobile">
            <img
              src={updateIcon}
              aria-hidden="true"
              className={`descriptionIcon ${isMobile ? "mobile" : ""}`}
            />
            <h2
              className={`h2-edgeComputing-features ${isMobile ? "mobile" : ""}`}
            >
              {
                textContent.edgeComputingSection.features.feature4.title[
                  language
                ]
              }
            </h2>
            <p className="p-edgeComputing">
              {
                textContent.edgeComputingSection.features.feature4.description[
                  language
                ]
              }
            </p>
          </div>
        ) : null}
      </div>

      <div className="container-empty-extra-small" />
      <div className={`edgeFeatures ${isMobile ? "mobile" : ""}`}>
        {!isMobile ? (
          <div className="edgeFeature">
            <img
              src={updateIcon}
              aria-hidden="true"
              className={`descriptionIcon ${isMobile ? "mobile" : ""}`}
            />
            <h2 className="h2-edgeComputing-features">
              {
                textContent.edgeComputingSection.features.feature4.title[
                  language
                ]
              }
            </h2>
            <p className="p-edgeComputing">
              {
                textContent.edgeComputingSection.features.feature4.description[
                  language
                ]
              }
            </p>
          </div>
        ) : null}
        <div className={`edgeFeature ${isMobile ? "mobile" : ""}`}>
          <img
            src={interoperableIcon}
            aria-hidden="true"
            className={`descriptionIcon ${isMobile ? "mobile" : ""}`}
          />
          <h2
            className={`h2-edgeComputing-features ${isMobile ? "mobile" : ""}`}
          >
            {textContent.edgeComputingSection.features.feature5.title[language]}
          </h2>
          <p className="p-edgeComputing">
            {
              textContent.edgeComputingSection.features.feature5.description[
                language
              ]
            }
          </p>

          {/* <a
            href={textContentSmarthomeContactUsSection.compatibleDevices.link}
            className={`edgeFeatureButton ${isMobile ? "mobile" : ""}`}
          >
            {
              textContentSmarthomeContactUsSection.compatibleDevices.title[
                language
              ]
            }
          </a> */}
        </div>
        <div className={`edgeFeature ${isMobile ? "mobile" : ""}`}>
          <img
            src={neverStopIcon}
            aria-hidden="true"
            className={`descriptionIcon ${isMobile ? "mobile" : ""}`}
          />
          <h2
            className={`h2-edgeComputing-features ${isMobile ? "mobile" : ""}`}
          >
            {textContent.edgeComputingSection.features.feature6.title[language]}
          </h2>
          <p className="p-edgeComputing">
            {
              textContent.edgeComputingSection.features.feature6.description[
                language
              ]
            }
          </p>
        </div>
      </div>
      <div className="container-empty-medium" />
    </section>
  );
}
